import React, { useEffect } from "react";
import "./RingingCall.css";

import { useDispatch, useSelector } from "react-redux";
import logo from "Media/Amnius_connect_noText.png";
import { useLocation, useNavigate } from "react-router-dom";
import { storeVideoChatLinkAction } from "Redux/action/get.action";
import { EndCallRinging } from "Config/API/action";
import { toast } from "react-toastify";
import blank from "Media/blank-profile-picture.png";

const RingingCall = () => {
    const location = useLocation();
  
    const { profile, call_user } = location.state || {};

  const msToken = useSelector((state) => state.storeVideoChatLinkReducer.token);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

const handleSocketMessage = (data) => {
  const { token, roomid: id, name, status } = data;
  const role = "host";
console.log(data)
  if (status === false) {
      toast("Call Rejected", {
          type: "success",
        });
   navigate("/chat");

    return;
  }

  navigate("/video-chat", { state: { call_user } });
  dispatch(
    storeVideoChatLinkAction({ token, id, name, role, from: "videoChat" })
  );
};

  const handleEndCall = async () => {
    try {
      const endcall = await EndCallRinging(token, msToken);
      if (endcall?.status) {
        navigate("/chat");
      
      } else {
           console.error(endcall?.message );
        // toast(endcall?.message || "Failed to end call", {
        //   type: "error",
        // });
      }
    } catch (err) {
      console.error("❌ Failed to end call:", err);
      // toast("Something went wrong", { type: "error" });
    }
  };

  useEffect(() => {
    let hosturl = window.location.hostname;
    let wsUrl =
      hosturl === "localhost"
        ? `wss://amnius-connect.ebizonstg.com/ws/`
        : `wss://${hosturl}/ws/`;

    const ws = new WebSocket(wsUrl);

    ws.onopen = () => {
      console.log("✅ Connected to WebSocket");
      ws.send(JSON.stringify({ type: "register", mstoken: msToken }));
    };

    ws.onmessage = (event) => {
      const message = JSON.parse(event.data);
      handleSocketMessage(message);
      console.log("📩 Message received:", message);
    };

    ws.onerror = (error) => {
      console.error("❌ WebSocket error:", error);
    };

    ws.onclose = () => {
       handleEndCall();
      console.log("🔌 WebSocket connection closed");
    };

    const timeout = setTimeout(() => {
      handleEndCall(); // <- Use the same function here
    }, 30000);

    return () => {
      ws.close();
      clearTimeout(timeout);
    };
  }, []);
console.log(profile)
  return (
    <div className="ringing-overlay">
      <div className="org-header-ringing">
        <div className="org-left-ringing">
          <img src={logo} alt="Logo" className="org-logo-ringing" />
          <span className="org-name-ringing">Amnius Connect</span>
        </div>
        <button className="end-call-btn" onClick={handleEndCall}>
          End Call
        </button>
      </div>

      <div className="ringing-container">
        <div className="pulse-ring">
          <img
            src={profile?.image||blank}
            alt="Caller Avatar"
            className="caller-avatar"
          />
        </div>
        <h2>{profile?.name} </h2>
        <p className="ringing-text">Ringing...</p>
      </div>
    </div>
  );
};


export default RingingCall;
